import Button from '../../Button'
import { Header } from '../../Modal'
import Box from '../../Modal/Box'
import Buttons from '../../Modal/Buttons'
import { Content } from '../../Modal/Content'
import { Container } from '../Container'

function ModalSizeXl({ children }) {
  return (
    <Container label='Modal, size XL - 936px, max height - 704px (not exist)'>
      <Box size='xl'>
        <Header text='Header text' />
        <Content size='xl'>{children}</Content>
        <Buttons size='xl'>
          <Button.Contained text='Save' />
          <Button.Outlined text='Cancel' />
        </Buttons>
      </Box>
    </Container>
  )
}

export default ModalSizeXl
